const displayFlex = {
    display: 'flex',
};

const displayInlineFlex = {
    display: 'inline-flex',
};

function flexDirection(direction) {
    return {
        flexDirection: direction,
    };
}

function flexWrap(wrap) {
    return {
        flexWrap: wrap,
    };
}

function flow(direction, wrap) {
    return {
        ...flexDirection(direction),
        ...flexWrap(wrap),
    };
}

function order(orderValue) {
    return {
        order: orderValue,
    };
}

function grow(growValue) {
    return {
        flexGrow: growValue,
    };
}

function shrink(shrinkValue) {
    return {
        flexShrink: shrinkValue,
    };
}

function basis(basisValue) {
    return {
        flexBasis: basisValue,
    };
}

function justifyContent(justify) {
    return {
        justifyContent: justify,
    };
}

function alignItems(align) {
    return {
        alignItems: align,
    };
}

function alignSelf(align) {
    return {
        alignSelf: align,
    };
}

function alignContent(align) {
    return {
        alignContent: align,
    };
}

const flex = {
    displayFlex,
    displayInlineFlex,
    flexDirectionRow: flexDirection('row'),
    flexDirectionRowReverse: flexDirection('row-reverse'),
    flexDirectionColumn: flexDirection('column'),
    flexDirectionColumnReverse: flexDirection('column-reverse'),
    flexDirectionInherit: flexDirection('inherit'),
    flexWrapNowrap: flexWrap('nowrap'),
    flexWrapWrap: flexWrap('wrap'),
    flexWrapWrapReverse: flexWrap('wrap-reverse'),
    flexWrapInherit: flexWrap('inherit'),
    justifyContentFlexStart: justifyContent('flex-start'),
    justifyContentFlexEnd: justifyContent('flex-end'),
    justifyContentCenter: justifyContent('center'),
    justifyContentSpaceBetween: justifyContent('space-between'),
    justifyContentSpaceAround: justifyContent('space-around'),
    justifyContentInherit: justifyContent('inherit'),
    alignItemsFlexStart: alignItems('flex-start'),
    alignItemsFlexEnd: alignItems('flex-end'),
    alignItemsCenter: alignItems('center'),
    alignItemsBaseline: alignItems('baseline'),
    alignItemsStretch: alignItems('stretch'),
    alignItemsInherit: alignItems('inherit'),
    alignSelfAuto: alignSelf('auto'),
    alignSelfFlexStart: alignSelf('flex-start'),
    alignSelfFlexEnd: alignSelf('flex-end'),
    alignSelfCenter: alignSelf('center'),
    alignSelfBaseline: alignSelf('baseline'),
    alignSelfStretch: alignSelf('stretch'),
    alignSelfInherit: alignSelf('inherit'),
    alignContentFlexStart: alignContent('flex-start'),
    alignContentFlexEnd: alignContent('flex-end'),
    alignContentCenter: alignContent('center'),
    alignContentSpaceBetween: alignContent('space-between'),
    alignContentSpaceAround: alignContent('space-around'),
    alignContentStretch: alignContent('stretch'),
    alignContentInherit: alignContent('inherit'),
    order,
    grow,
    shrink,
    basis,
    flow,
};

export default flex;
